<script setup lang="ts">
import type { SearchHintsProps } from '@/features/SearchHints/model/types/searchHints';

import AppScrollbar from '@/shared/ui/AppScrollbar/index';
import SearchHintsList from '@/features/SearchHints/ui/SearchHintsList.vue';

defineProps<SearchHintsProps>();

const emit = defineEmits<{
  (e: 'hide'): void;
}>();

const vm = getCurrentInstance();

const clickHandler = (e: Event): void => {
  if (!vm?.proxy?.$el.contains(e.target)) {
    emit('hide');
  }
};

onMounted(() => {
  document.addEventListener('pointerdown', clickHandler);
});

onUnmounted(() => {
  document.removeEventListener('pointerdown', clickHandler);
});
</script>

<template>
  <div class="search-hints" data-testid="search-hints">
    <AppScrollbar v-if="items.length" height="440" class="search-hints__scrollbar">
      <div class="search-hints__result _success">
        <SearchHintsList :items="items" :query="query" />
      </div>
      <div class="search-hints__result _all">
        <NuxtLink
          class="search-hints__link _all"
          data-testid="search-hints-all-link"
          :to="`/juristes-advocates/?q=${query}`"
        >
          Смотреть все результаты
        </NuxtLink>
      </div>
    </AppScrollbar>
  </div>
</template>

<style lang="less">
.search-hints {
  background: inherit;
  z-index: 10;
  border-radius: @main-size;

  &__result {
    &._not-found {
      font-size: 13px;
      font-weight: 500;
      color: @color-manatee;
      padding: @size-x4 @size-x6;
    }

    &._all {
      margin-top: @size-x4;
      margin-bottom: @size-x7;
    }
  }

  &__link {
    width: 100%;
    padding: 0 30px 0 @size-x5;

    &._all {
      display: block;
      font-size: 14px;
      line-height: 19px;
      font-weight: 700;
      color: @color-persimmon;
      width: 100%;
      padding: 0 @size-x6 0 @size-x5;
    }

    &:hover {
      background-color: #e2e2e2;
      box-shadow: 0px @size-x2 @size-x6 rgba(129, 135, 189, 0.15);
    }
  }
}
</style>
